import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './address.component.scss';
var Address = /** @class */ (function (_super) {
    tslib_1.__extends(Address, _super);
    function Address(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('mapInitialised', null, _this.setMapOptions.bind(_this));
        return _this;
    }
    Address.prototype.init = function () { };
    Address.prototype.bindEvents = function () { };
    Address.prototype.setMarkers = function (markers) {
        var _this = this;
        var _loop_1 = function (marker) {
            var markerInstance = new google.maps.Marker({
                position: marker.coordinates,
                icon: marker.icon,
                title: marker.title,
                map: this_1.map
            });
            var infoWindow = new google.maps.InfoWindow({
                content: marker.info
            });
            markerInstance.addListener('click', function () {
                infoWindow.open(_this.map, marker);
            });
        };
        var this_1 = this;
        for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
            var marker = markers_1[_i];
            _loop_1(marker);
        }
    };
    Address.prototype.setMapOptions = function (event, mapData) {
        this.map = mapData.map;
        this.setMarkers(mapData.options.markers);
        /* const infowindow = new google.maps.InfoWindow({
            content: "<strong>test</strong>"
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map,marker);
        });

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(mapLatLng);
        }); */
    };
    return Address;
}(Base));
export { Address };



//////////////////
// WEBPACK FOOTER
// ./components/address/address.component.ts
// module id = 85
// module chunks = 0